import { TieBreaker } from "@/gen/realtime";

export const pluralize = (count: number, singular: string, plural: string) => {
    return count === 1 ? singular : plural;
};

export function printTieBreaker(tb: TieBreaker) {
    const { t: type, c: content } = tb;

    if (!content) {
        return type;
    }

    const setting = Object.entries(content)
        .map(
            ([key, value]) =>
                `${key[0].toUpperCase()}${key.slice(1)}: ${value != null ? value : "Not set"}`
        )
        .join(", ");

    const settingText = setting.length > 0 ? `(${setting})` : "";
    return `${type} ${settingText}`;
}
